module.exports = __webpack_public_path__ + "img/ring_g_0_1_1@3x.0bfa6caf.png";